import * as constants from './constants'

export const fetchLocationsByName = (name, page = 0) => ({
    type: constants.SEARCH_REQUEST_LOCATIONS_BY_NAME,
    name,
    page,
})

export const stopLocationsFetch = () => ({
    type: constants.STOP_SEARCH_REQUEST,
})

export const clearSearchLocations = () => ({
    type: constants.CLEAR_SEARCH_LOCATIONS,
})

export const clearGoogleSearchLocations = () => ({
    type: constants.CLEAR_GOOGLE_SEARCH_LOCATIONS,
})

export const locationsReceived = (results, resultsCount) => ({
    type: constants.SEARCH_LOCATIONS_RECEIVED,
    results,
    resultsCount: resultsCount === undefined ? results.length : resultsCount,
})

export const googleLocationsReceived = locations => ({
    type: constants.GOOGLE_SEARCH_LOCATIONS_RECEIVED,
    ...locations,
})

export const setLocation = location => ({
    type: constants.SELECT_SEARCH_LOCATION,
    location,
})

export const removeLocation = () => ({
    type: constants.REMOVE_SEARCH_LOCATION,
})

/* EVENTS */

export const fetchEvents = ({ eventName, startDate, endDate, locationId }) => ({
    type: constants.SEARCH_REQUEST_EVENTS,
    eventName,
    startDate,
    endDate,
    locationId,
})

export const eventsReceived = results => ({
    type: constants.SEARCH_EVENTS_RECEIVED,
    results,
})

export const clearSearchEvents = () => ({
    type: constants.CLEAR_SEARCH_EVENTS,
})

export const setEvent = event => ({
    type: constants.SET_EVENT,
    event,
})

export const addEventDetails = rateDetails => ({
    type: constants.ADD_EVENT_DETAILS,
    rateDetails,
})

export const removeEvent = () => ({
    type: constants.REMOVE_EVENT,
})

export const setSearchEventInputValue = event => ({
    type: constants.SET_SEARCH_EVENT_INPUT_VALUE,
    event,
})

export const removeSearchEventInputValue = () => ({
    type: constants.REMOVE_SEARCH_EVENT_INPUT_VALUE,
})
